import Vue from 'vue'

Vue.config.errorHandler = e => {
  console.error(e.message)
  const toast = Vue.prototype.$toast
  toast.error(e.message)
  // alert(e.message)
}
